<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="MoveTopics"
    title="Move Topics"
    submit-name="Move topics"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <p class="text-gray-700 mb-4">
      Please select the Actor where the selected topics will be moved:
    </p>
    <lm-actor-select ref="actorSelect" check-rights show-placeholder />
  </form-modal>
</template>

<script>
import EventHub from '@/lib/eventHub'
import {mapGetters} from 'vuex'
import {Events, Modal} from '@/lib/definitions'
import FormHelper from '@/components/form/formHelper'
import FormModal from '@/components/modals/FormModal'
import LmActorSelect from '@/components/form/LmActorSelect'

export default {
  name: 'ModalMoveTopics',
  components: {
    LmActorSelect,
    FormModal
  },
  data() {
    return {
      Events,
      modalName: Modal.MOVE_TOPICS,
      modalRef: null,
      inputs: null,
      actorPathArr: null,
      numTopics: 0
    }
  },
  computed: {
    ...mapGetters(['bulkTopics', 'getActorByID'])
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [this.$refs.actorSelect]
  },
  methods: {
    submit() {
      if (FormHelper.validate(this.inputs)) {
        this.numTopics = this.bulkTopics.length
        const payload = {action: 'move', actorId: this.$refs.actorSelect.data}
        this.$store
          .dispatch('bulkTopics', payload)
          .then(() => {
            this.modalRef.submitSuccess()
          })
          .catch(error => this.modalRef.submitFails(error))
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        const n = this.numTopics
        const topic = this.$options.filters.pluralizeWord('Topic', n)
        const actor = this.getActorByID(this.$refs.actorSelect.data)
        const msg = `${n} ${topic} has been moved to ${actor.name}`
        EventHub.emit(Events.SHOW_SNACKBAR, msg)
      }
    }
  }
}
</script>
